import { OvernightUpdateScreen } from "~/session/overnight-update/overnight-update-screen";

// /session/:id/patient/:patientId/overnight-update — record the end-of-shift
// overnight update for a patient (V2-E8.1). Editable only by the session's
// incoming doctor; the screen shows the original SBAR read-only alongside the
// update fields and the API enforces the same gating.
export default function OvernightUpdateRoute(): JSX.Element {
  return <OvernightUpdateScreen />;
}
